import styled from 'styled-components';
import { ReactComponent as LogoIcon } from '@images/logos/logo.svg';
export const StyledLogoBox = styled.div`
  padding: 30px 60px;
  @media (max-width: ${props => props.theme.screen.l}) {
    padding: 40px;
  }
  @media (max-width: ${props => props.theme.screen.md}) {
    padding: 60px 30px 0;
  }
`;
export const StyledLogoIcon = styled(LogoIcon)`
  width: 100px;
`;
